/**
 * Keep only digits and AT MOST ONE decimal separator ('.' or ','). A
 * separator is kept only if at least one digit precedes it (cannot start
 * with a separator). Any other character is dropped.
 */
export const sanitizeDecimalInput = (value: string): string => {
  let result = '';
  let hasSeparator = false;
  let hasDigit = false;
  for (const ch of value) {
    if (ch >= '0' && ch <= '9') {
      result += ch;
      hasDigit = true;
    } else if ((ch === '.' || ch === ',') && hasDigit && !hasSeparator) {
      result += ch;
      hasSeparator = true;
    }
  }
  return result;
};

/** Normalize a sanitized decimal string to use '.' as the separator (forms often need this). */
export const normalizeDecimal = (value: string): string => value.replace(',', '.');
